import { Component } from '@angular/core';

@Component({
  selector: 'app-report-wallgarden-badge',
  templateUrl: './report-wallgarden-badge.component.html',
  styleUrls: ['./report-wallgarden-badge.component.scss']
})
export class ReportWallgardenBadgeComponent {

}
